import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CancelToken, isCancel } from 'axios';

import TagService from '../../Services/TagService';
import AssetTagDisplay from './AssetTagDisplay';

export default class AssetTagContainer extends Component {
  static propTypes = {
    updateTags: PropTypes.func,
    asset: PropTypes.object,
    visibility: PropTypes.string,
  };

  static defaultProps = {
    asset: {},
  };

  state = {
    createTagRequestPending: false,
    nameSuggestions: [{ value: '', label: '' }],
    deleteTagRequestPending: '',
    dropdownLoading: false,
    tags: [],
    error: '',
    tagName: {},
    tagValue: '',
  };

  tagService = new TagService();
  source = CancelToken.source();

  componentDidMount() {
    if (this.props.asset.tags) {
      this.setState({
        tags: this.props.asset.tags,
      });
    }
  }

  componentWillUnmount() {
    this.source.cancel();
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    if (this.state.tags.length >= 20) return;
    this.setState({ createTagRequestPending: true });
    try {
      const newTag = await this.tagService.createNewTag(
        this.props.asset._id,
        this.props.asset.orgID,
        {
          name: this.state.tagName.label,
          value: this.state.tagValue,
        },
        this.source.token
      );
      const tags = [...this.state.tags, newTag];
      this.setState({ tags, createTagRequestPending: false });
      this.props.updateTags && this.props.updateTags(tags);
      this.setState({
        tagName: {},
        tagValue: '',
        nameSuggestions: [{ value: '', label: '' }],
      });
    } catch (err) {
      if (isCancel(err)) return;
      const error = err.response?.data?.message ?? err.message;
      this.setState({ error, createTagRequestPending: false });
    }
  };

  handleDelete = async (tagID) => {
    this.setState({ deleteTagRequestPending: tagID });
    try {
      await this.tagService.deleteTag(
        this.props.asset._id,
        tagID,
        this.props.asset.orgID,
        this.source.token
      );
      const tags = this.state.tags.filter(({ _id }) => _id !== tagID);
      this.setState({ tags, deleteTagRequestPending: '' });
      this.props.updateTags(tags);
    } catch (err) {
      if (isCancel(err)) return;
      const error = err.response?.data?.message ?? err.message;
      this.setState({ error, deleteTagRequestPending: '' });
    }
  };

  suggestNames = async (nameSearch) => {
    this.setState({ dropdownLoading: true });
    try {
      const response = await this.tagService.getTagNames(
        this.props.asset.orgID,
        nameSearch,
        this.source.token
      );
      const currentTags = response.map(({ name }) => name);
      const nameSuggestions = Array.from(new Set(currentTags)).map((label) => ({
        label,
      }));
      this.setState({ nameSuggestions, dropdownLoading: false });
    } catch (err) {
      if (isCancel(err)) return;
      const error = err.response?.data?.message ?? err.message;
      this.setState({ error, dropdownLoading: false });
    }
  };
  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value });
  };

  handleNameInput = (input) => {
    if (this.timeout) {
      window.clearTimeout(this.timeout);
    }
    if (input.length < 2) return;
    this.timeout = setTimeout(() => {
      this.suggestNames(input);
    }, 500);
  };

  handleNameSelect = (tagName = {}) => {
    this.setState({ tagName });
  };

  handleBlur = (e) => {
    const { value } = e.target;
    if (!value.length) return;
    this.setState({ tagName: { label: value, value } });
  };

  render() {
    const {
      createTagRequestPending,
      dropdownLoading,
      nameSuggestions,
      deleteTagRequestPending,
      tagName,
      tagValue,
      tags,
    } = this.state;
    return (
      <AssetTagDisplay
        visibility={this.props.visibility}
        tags={tags}
        handleChange={this.handleChange}
        handleSubmit={this.handleSubmit}
        handleDelete={this.handleDelete}
        createTagRequestPending={createTagRequestPending}
        dropdownLoading={dropdownLoading}
        nameSuggestions={nameSuggestions}
        handleNameSelect={this.handleNameSelect}
        handleNameInput={this.handleNameInput}
        handleBlur={this.handleBlur}
        deleteTagRequestPending={deleteTagRequestPending}
        tagName={tagName}
        tagValue={tagValue}
      />
    );
  }
}
